import { Select, Space } from "antd";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";

const { Option } = Select;

const ChannelMemberFilter = (props) => {
  /** *
   *  props.memberId REQUIRED.
   *  Optional: memberTags along with OnTeamTagAdded and teamTags if you already have a list
   *  If only memberTags isnt provided this component will assume you want to pull the member tags and team tags in the compoennt itself
   */

  // props.onChange --> function in parent component to call when tag is selected/deselected
  // props.teamId --> teamId used to fetch tags for team
  const supabase = getSupaClient();
  const [selectedChannel, setSelectedChannel] = useState(
    props.selected ? props.selected : ""
  );
  const [channels, setChannels] = useState([]);

  const loadChannels = async () => {
    const { data, error } = await supabase
      .from("channels")
      .select("slack_id, name")
      .filter("is_deleted", "eq", false)
      .filter("is_archived", "eq", false)
      .eq("team", props.teamId);
    if (data) {
      setChannels(data);
    }
    if (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    loadChannels();
  }, []);

  const onSelect = async (selection) => {
    setSelectedChannel(selection);
    if (props.channelJoin) {
      const selected = channels.find((item) => item.slack_id === selection);
      props.onChange({
        channel: {
          name: selected.name,
          id: selected.slack_id,
        },
      });
    } else if (props.onChange) {
      props.onChange({
        filter_type: "channel_member",
        filter_settings: { channel: selection },
      });
    }
  };

  const onDeselect = async () => {
    setSelectedChannel("");
    if (props.channelJoin) {
      props.onChange({});
    } else if (props.onChange)
      props.onChange({
        filter_type: "channel_member",
      });
  };

  return (
    <>
      <Space>
        <span>Select channel: </span>
        <Select
          showSearch
          showArrow
          value={selectedChannel}
          style={{ width: "500px", borderRadius: 10 }}
          onSelect={onSelect}
          onDeselect={onDeselect}
          optionFilterProp="name"
        >
          {channels.map((item) => {
            return (
              <Option
                key={item.slack_id}
                value={item.slack_id}
                name={item.name}
              >
                # {item.name}
              </Option>
            );
          })}
        </Select>
      </Space>
    </>
  );
};

export default ChannelMemberFilter;
